module.exports = __webpack_public_path__ + "static/media/hubspotHero.323a8b82.png";